import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "react-quill/dist/quill.snow.css";
import ReactSummernote from "react-summernote";
import "react-summernote/dist/react-summernote.css";
import toast from "react-hot-toast";
import $ from "jquery";
import { addEmailTemplate } from "../actions/admin";

window.$ = window.jQuery = $;

const AddEmailTemplateModal = ({ show, handleClose, getTemplates }) => {
  const [formvalue, setFormvalue] = useState({
    identifier: "",
    subject: "",
  });

  const [content, setContent] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormvalue({ ...formvalue, [name]: value });
  };

  const handleEdit = (e) => {
    setContent(e);
  };

  const validate = () => {
    const errors = {};
    if (!formvalue.identifier.trim()) errors.identifier = "Identifier is required";
    if (!formvalue.subject.trim()) errors.subject = "Subject is required";
    if (!content.trim()) errors.content = "Content is required";
    return errors;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      const payload = {
        identifier: formvalue.identifier.trim(),
        subject: formvalue.subject.trim(),
        content,
      };

      const { status, message } = await addEmailTemplate(payload);
      if (status) {
        toast.success(message || "Template added successfully");
        handleClose();
        getTemplates?.();
        setFormvalue({ identifier: "", subject: "" });
        setContent("");
      } else {
        toast.error(message || "Failed to add template");
      }
    } catch (err) {
      console.error("Error submitting template:", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <Modal centered className="cmn_modal" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Body>
        <div className="cmn_modal_header d-flex justify-content-between align-items-center mb-4">
          <p className="cmn_modal_title">Add New Template</p>
          <button className="cmn_modal_closer rounded-5" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <div className="rp_singleinput_holder mb-3">
          <p className="rp_label mb-2">Identifier</p>
          <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
            <input
              type="text"
              name="identifier"
              placeholder="Enter Identifier"
              className="rp_singleInput flex-grow-1"
              value={formvalue.identifier}
              onChange={handleChange}
            />
          </div>
          {errors.identifier && <small className="text-danger">{errors.identifier}</small>}
        </div>

        <div className="rp_singleinput_holder mb-3">
          <p className="rp_label mb-2">Subject</p>
          <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
            <input
              type="text"
              name="subject"
              placeholder="Enter Subject"
              className="rp_singleInput flex-grow-1"
              value={formvalue.subject}
              onChange={handleChange}
            />
          </div>
          {errors.subject && <small className="text-danger">{errors.subject}</small>}
        </div>

        <div className="rp_singleinput_holder mb-3">
          <p className="rp_label mb-2">Content</p>
          <div className="custom_reactSummerNote">
            <ReactSummernote
              value={content}
              options={{
                height: 250,
                dialogsInBody: true,
                toolbar: [
                  ["font", ["bold", "underline", "clear"]],
                  ["para", ["ul", "ol", "paragraph"]],
                  ["view", ["codeview"]],
                ],
              }}
              onChange={handleEdit}
            />
          </div>
          {errors.content && <small className="text-danger">{errors.content}</small>}
        </div>

        <button className="orange_small_primary mt-3" onClick={handleSubmit}>
          Submit
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default AddEmailTemplateModal;
